import React from "react";
import GitHubCalendar from "react-github-calendar";
import "./Calendar.css";


function Calendar() {
  return (
    <>
    <div className="calendar"   style={{
        backgroundColor: "rgb(71, 32, 88)",
        color : "white"
      }}   >
      <div className="head_text">
        <h2 className="x">
          Days I <span className="x"> Code</span>
        </h2>
      </div>
      <div className="Graph">
        <GitHubCalendar username="akshaykumargaurav" />
      </div>
    </div>

 
    <h2 align="center" className="xx">📊 My Github </h2>
      <div className='stats'        
      style={{
        display : "flex",
        gap : "20px" ,
        backgroundColor: "rgb(71, 32, 88)",
        color : "white"
      }}   >
        <img id="github-top-langs" src="https://github-readme-stats.vercel.app/api/top-langs?username=akshaykumargaurav&show_icons=true&theme=highcontrast&locale=en&layout=compact" alt="akshaykumargaurav" />
        <img  id="github-streak-stats" src="https://github-readme-streak-stats.herokuapp.com?user=akshaykumargaurav&show_icons=true&&theme=highcontrast&ring=38EBDA"  alt="stats" />
        <img   id="github-stats-card" src="https://github-readme-stats.vercel.app/api?username=akshaykumargaurav&show_icons=true&&theme=highcontrast&ring=38EBDA" alt="Github tropy" />
      </div>
      

    </>
  );
}

export default Calendar;
// GitHub streak stats : id="github-streak-stats" [Link to refer : https://github-readme-streak-stats.herokuapp.com/demo/]
// GitHub top languages : id="github-top-langs" [Link to refer : https://github.com/anuraghazra/github-readme-stats]
// GitHub stats card : id="github-stats-card" [Link to refer : https://github.com/anuraghazra/github-readme-stats]

 